document.addEventListener('DOMContentLoaded', async () => {
  const params = new URLSearchParams(window.location.search);
  const brand = params.get('name');
  if (!brand) return;
  const brandNamePretty = brand
  .replace(/-/g, ' ')
  .replace(/\b\w/g, l => l.toUpperCase());

const breadcrumbEl = document.getElementById('breadcrumb-brand');
if (breadcrumbEl) {
  breadcrumbEl.textContent = brandNamePretty;
}


  /* LOGO MAP */
  const logos = {
    thorne: 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/download-6a2a16cd.webp',
    resmed: 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/resmed-logo.webp',
    boveda: 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/Boveda.jpg',
    'mobil-1': 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/ChatGPT_Image_Mar_16_2026_07_31_18_AM.png?v=1773617487',
    sylvania: 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/ChatGPT_Image_Mar_16_2026_07_26_22_AM.png?v=1773617203',
    'red-line': 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/ChatGPT_Image_Mar_16_2026_07_29_30_AM.png?v=1774081245',
    gooloo: 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/ChatGPT_Image_Mar_17_2026_07_23_11_AM.png?v=1773703418',
    Gila: 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/Gila_brand_logo_design.png?v=1775757327',
    'lucas-oil': 'https://cdn.shopify.com/s/files/1/0699/4214/9396/files/ChatGPT_Image_Mar_17_2026_07_27_36_AM.png?v=1773703670',
    ...(window.__dmBrandLogos || {})
  };

  const logoEl = document.getElementById('brand-logo');
  if (logoEl && logos[brand]) logoEl.src = logos[brand];

  /* FETCH PRODUCTS */
  const res = await fetch(`/collections/${brand}/products.json`);
  const data = await res.json();
  const products = data.products;

  const popular = products.slice(0, 3);
  const all = products;

  const createCard = p => {
  const v = p.variants[0];

  return `
    <div class="product-card">
      <a href="/products/${p.handle}">
        <img src="${p.images[0]?.src || ''}">
      </a>

      <div class="product-title">${p.title}</div>

      <div class="price">$${v.price}</div>

      <div class="delivery-line dm-delivery-line">
        <span class="green-dot dm-green-dot" aria-hidden="true"></span>
        FREE delivery <span class="dm-delivery-date"></span>
      </div>

      <button type="button" class="add-to-cart dm-add-to-cart-btn" data-variant-id="${v.id}">
        Add to Cart
      </button>
    </div>
  `;
};


  document.getElementById('popular-products').innerHTML =
    popular.map(createCard).join('');

  document.getElementById('all-products').innerHTML =
    all.map(createCard).join('');

  if (window.DMProductCards && typeof window.DMProductCards.fillDeliveryDates === 'function') {
    window.DMProductCards.fillDeliveryDates(document.getElementById('popular-products'));
    window.DMProductCards.fillDeliveryDates(document.getElementById('all-products'));
  }
});
